class TelegramService {
  constructor() {
    this.botToken = ""
    this.channelId = ""
    this.serverUrl = "http://localhost:3001"
    this.maxRetries = 3
  }

  init(botToken, channelId) {
    this.botToken = botToken
    this.channelId = channelId
  }

  async sendMessage(message, imageUrl = null) {
    if (!this.botToken || !this.channelId) {
      console.error("Не установлены botToken или channelId")
      return { success: false, error: "Не установлены botToken или channelId" }
    }

    try {
      console.log("Отправка сообщения в Telegram...")

      // Сразу пробуем прямой запрос к Telegram API, минуя прокси
      console.log("Отправка напрямую в Telegram API...")
      const result = await this.sendMessageDirect(message, imageUrl)
      return result
    } catch (error) {
      console.error("Ошибка при отправке сообщения в Telegram:", error)
      return { success: false, error: error.message }
    }
  }

  async sendMessageViaProxy(message, imageUrl) {
    // Подготовка данных для запроса
    const requestData = {
      botToken: this.botToken,
      channelId: this.channelId,
      message: message,
    }

    // Если есть изображение, добавляем его в запрос
    if (imageUrl) {
      requestData.imageUrl = imageUrl
    }

    // Отправка запроса с повторными попытками
    for (let attempt = 1; attempt <= this.maxRetries; attempt++) {
      try {
        console.log(
          `Отправка сообщения через прокси: ${this.serverUrl}/api/telegram/send (попытка ${attempt}/${this.maxRetries})`,
        )

        const response = await fetch(`${this.serverUrl}/api/telegram/send`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        })

        // Проверяем статус ответа
        if (!response.ok) {
          const errorText = await response.text()
          throw new Error(`Ошибка прокси: ${errorText || response.statusText}`)
        }

        const data = await response.json()
        console.log("Сообщение успешно отправлено через прокси")
        return { success: true, messageId: data.messageId }
      } catch (error) {
        console.error(`Попытка ${attempt}/${this.maxRetries} неудачна: ${error.message}`)

        // Если это последняя попытка, выбрасываем ошибку
        if (attempt === this.maxRetries) {
          throw error
        }

        // Иначе ждем перед следующей попыткой
        await new Promise((resolve) => setTimeout(resolve, 1000))
      }
    }
  }

  async sendMessageDirect(message, imageUrl) {
    try {
      console.log("Прямая отправка сообщения в Telegram...")

      // Базовый URL для API Telegram
      const apiUrl = `https://api.telegram.org/bot${this.botToken}`

      let response
      let result

      // Если есть изображение, отправляем его с подписью
      if (imageUrl) {
        console.log(`Отправка изображения: ${imageUrl}`)

        // Проверяем длину сообщения для подписи (Telegram ограничивает до 1024 символов)
        const caption = message.length > 1024 ? message.substring(0, 1021) + "..." : message

        try {
          // Используем fetch с методом GET для отправки фото
          const photoUrl = `${apiUrl}/sendPhoto?chat_id=${encodeURIComponent(this.channelId)}&photo=${encodeURIComponent(imageUrl)}&caption=${encodeURIComponent(caption)}&parse_mode=HTML`

          response = await fetch(photoUrl)

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
          }

          result = await response.json()
        } catch (photoError) {
          console.warn("Не удалось отправить изображение, отправляем только текст:", photoError.message)

          // Если не удалось отправить изображение, отправляем только текст
          const textUrl = `${apiUrl}/sendMessage?chat_id=${encodeURIComponent(this.channelId)}&text=${encodeURIComponent(message)}&parse_mode=HTML`

          response = await fetch(textUrl)

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
          }

          result = await response.json()
        }
      } else {
        // Если изображения нет, отправляем только текст
        console.log("Отправка текстового сообщения")

        // Используем fetch с методом GET
        const textUrl = `${apiUrl}/sendMessage?chat_id=${encodeURIComponent(this.channelId)}&text=${encodeURIComponent(message)}&parse_mode=HTML`

        response = await fetch(textUrl)

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }

        result = await response.json()
      }

      if (!result.ok) {
        throw new Error(`Ошибка Telegram API: ${result.description}`)
      }

      console.log("Сообщение успешно отправлено напрямую в Telegram")
      return { success: true, messageId: result.result.message_id }
    } catch (error) {
      console.error("Ошибка при прямой отправке в Telegram:", error)
      throw error
    }
  }
}

export default new TelegramService()

